module.exports = __webpack_public_path__ + "static/media/port-offline.1e0750eb.png";